<template>
  <div v-loading="loading"
    class="testimonials slick-wrapper"
    data-aos="fade-in" data-aos-once="true" v-if="testimonials && visible">
    <slick ref="slick" :options="slickOptions">
      <div class="item-wrapper"
        v-for="(item, index) in testimonials"
        :key="`${index}`"
        :caption="item.title">
        <div class="container is-fluid"
          style="padding-top:0;padding-bottom:30px;margin-left:0;margin-right:0;">
          <div class="container content">
            <div class="columns is-centered has-text-centered">
              <div class="column is-7">
                <div class="text tight margin-top">
                  {{ item.content }}
                </div>
                <div class="title tight margin-top" style="font-weight:bold;">
                  {{ item.title }}
                </div>
                <div class="title tight margin-top" style="font-weight:bold;margin-top:4px;"
                  v-if="item.subtitle && item.subtitle.length > 0">
                  {{ item.subtitle }}
                </div>
                <!-- <div class="subtitle margin-top">
                  {{ item.link }}
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- </lightbox> -->
    </slick>
  </div>
</template>

<script>
import Slick from 'vue-slick'
import EventBus from '@/controllers/EventBus'
import Site from '@/apis/site'

export default {
  name: 'testimonials',
  components: {
    Slick
  },
  data () {
    return {
      isDesktop: true,
      visible: true,
      loading: false,
      error: undefined,
      slickOptions: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true,
        fade: false,
        speed: 1000,
        swipe: false,
        swipeToSlide: false,
        touchMove: false,
        autoplay: true,
        autoplaySpeed: 4000,
        pauseOnHover: false,
        pauseOnFocus: false,
        pauseOnDotsHover: false,
        focusOnSelect: false,
        responsive: [
          {
            breakpoint: 1008,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true,
              dots: true
            }
          }, {
            // 768 = tablet (not break yet)
            breakpoint: 769,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: false,
              dots: true
            }
          }, {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: false,
              dots: true
            }
          }
        ]
      },
      testimonials: [
        {
          title: 'Siobhan Stewart - Teacher of the Deaf/HH',
          content: 'AIS is not just another contracting company. It is run by professionals who have experience in the field. The connections and resources they provide are invaluable!'
        }, {
          title: 'Siobhan Stewart - Teacher of the Deaf/HH',
          content: 'AIS is not just another contracting company. It is run by professionals who have experience in the field. The connections and resources they provide are invaluable!'
        }
      ],
    }
  },
  computed: {
  },
  watch: {
  },
  created () {
    // console.log('created Landing.vue')
  },
  async mounted () {
    // console.log('mounted Landing.vue')
    // window.GA('send', 'pageview')

    if (this.$route.query && this.$route.query.anchor) {
      console.log('automatic scroll to...: ' + this.$route.query.anchor)
      setTimeout(function () {
        this.$scrollTo('#' + this.$route.query.anchor)
      }.bind(this), 1000)
    }

    // on event resize
    this.isDesktop = EventBus._isDesktop
    EventBus.$on('isDesktopChanged', function () {
      this.isDesktop = EventBus._isDesktop
    }.bind(this))

    await this.refresh()
  },
  methods: {
    async refresh () {
      try {
        this.$set(this, 'loading', true)
        let promises = []
        let promise
        promise = this.getTestimonials()
        promises.push(promise)
        await Promise.all(promises)
        this.$set(this, 'loading', false)
      } catch (error) {
        this.$set(this, 'loading', false)
        this.$message({
          message: `Refresh failed: ${error.message || error}`,
          type: 'error'
        })
      }
    },

    async getTestimonials () {
      this.$set(this, 'visible', false)
      this.$set(this, 'testimonials', [])
      let data = await Site.testimonials()
      // console.log('-- data testimonials', data)
      this.$set(this, 'testimonials', data)
      await this.$nextTick()
      this.$set(this, 'visible', true)
      this.reInit()
    },

    onScrollTo (name, target) {
      if (this.$route.name !== name) {
        this.$router.replace({ name: name, query: { anchor: target } })
      } else {
        this.$scrollTo('#' + target, { offset: -30 })
      }
    },

    next () {
      if (this.$refs.slick) {
        this.$refs.slick.next()
      }
    },
    prev () {
      if (this.$refs.slick) {
        this.$refs.slick.prev()
      }
    },
    reInit () {
      if (this.$refs.slick) {
        this.$refs.slick.reSlick()
      }
    }
  }
}
</script>

<style lang="scss" src="../../styles/slick.scss"></style>
<style scoped lang="scss">
@import "../../styles/base.scss";

.testimonials {

  .content {
    // padding-top: 30px;

    @media screen and (max-width: $desktop - 1) {
      padding-left: 1.75rem;
      padding-right: 1.75rem;
    }

    img {
      max-width: 100%;
      // @media screen and (max-width: $tablet - 1) {
      //   max-width: 400px;
      // }
    }

    .title {
      &.tight {
        margin-bottom: 0;
      }
      &.margin-top {
        margin-top: 15px;
      }
    }
    .subtitle, h3 {
      margin-top: 30px;
      margin-bottom: 0;
      &.tight {
        margin-bottom: 0;
      }
      &.margin-top {
        margin-top: 15px;
      }
    }
    .text, p {
      margin-top: 8px;
      margin-bottom: 20px;
      &.tight {
        margin-bottom: 0;
      }
      &.margin-top {
        margin-top: 15px;
      }
    }
  }

  .slick-wrapper {
    overflow-x: hidden;
  }
}

</style>
